var _desc, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 640",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Drag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.000000, 28.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 45,
    r: 45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 228,
    r: 45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 228,
    r: 45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 411,
    r: 45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 411,
    r: 45
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 527,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by rupa c")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 532,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.6c925229c573e10f464883d126a7c393.svg";
export { ForwardRef as ReactComponent };